// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__O_QTa","header":"MessagesList_header__1kvs_","chat":"MessagesList_chat__vR8qp"};